import React from "react";
import {
    Container,
    Title,
} from "./ContributingUI";
import Guidelines from "./Guidelines";
import ContributorGuidelines from "./ContributorGuidelines";

const Contributing = () => {
    return (
        <Container>
            <Title>GSoC 2026 Contributor Guide</Title>
            <Guidelines />
            <ContributorGuidelines />
        </Container>
    );
};

export default Contributing;
